import { useReduxState } from 'hooks';
import { CopyButton } from '.';

interface Props {
  value: string;
}

const TemplateVariable = ({ value }: Props) => {
  const { messages } = useReduxState();

  return (
    <CopyButton
      aria-label={messages.commonCopy}
      data-tooltip={messages.commonCopy}
      buttonStyle={{
        fontSize: '1.3rem',
        fontWeight: 600,
        margin: '5px 10px 5px 0',
        padding: '3px 5px 4px'
      }}
      category="lighter"
      icon={null}
      size="small"
      successText={messages.commonCopied}
      text={`{{{${value}}}}`}
      value={`{{{${value}}}}`}
    />
  );
};

export default TemplateVariable;
